import { render } from "./ContractAdditionalEditComponent.vue?vue&type=template&id=6682ccc4&scoped=true"
import script from "./ContractAdditionalEditComponent.vue?vue&type=script&lang=js"
export * from "./ContractAdditionalEditComponent.vue?vue&type=script&lang=js"

import "./ContractAdditionalEditComponent.vue?vue&type=style&index=0&id=6682ccc4&scoped=true&lang=css"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6682ccc4"]])

export default __exports__